import Image from '@anm/components/image/Image';
import Dialog, { DialogProps } from '@anm/components/modals/Dialog';
import AlertBlock from '@anm/components/notification/AlertBlock';
import isEmail from '@anm/helpers/is/isEmail';
import noop from '@anm/helpers/noop';
import { FC } from 'react';

import Wrapper, { EmailInput } from './Wrapper';
import { useAlertHandlers } from './hooks';

const startText =
  'We’ve sent you a direct link to edit the video template of your choice';
const endText = 'open the link on your computer to start editing.';

const MobileAlert: FC<DialogProps> = ({
  onModalClose = noop,
  ...otherProps
}) => {
  const [
    email,
    userEmail,
    handleButtonClick,
    hanleInputChange
  ] = useAlertHandlers(onModalClose);
  const guestMainText = `. Please enter your email and `;
  const userMainText = ` to <b>${userEmail}</b>. Please `;

  const userText = `${startText}${userMainText}${endText}`;
  const guestText = `${startText}${guestMainText}${endText}`;

  const description = userEmail ? userText : guestText;

  return (
    <Dialog {...{ ...otherProps, onModalClose }}>
      <Wrapper isValidEmail={isEmail(email)} isButton={!userEmail}>
        <AlertBlock
          title="Switch to desktop"
          {...{ description }}
          button={{
            text: 'Send it here!',
            size: 'upper-medium',
            variant: 'yellow'
          }}
          onButtonClick={handleButtonClick}
          renderTopContent={() => (
            <Image
              alt="letter"
              src="images/icons/notification/template-email.png"
            />
          )}
        >
          {!userEmail && (
            <EmailInput
              value={email}
              placeholder="Email"
              onChange={hanleInputChange}
            />
          )}
        </AlertBlock>
      </Wrapper>
    </Dialog>
  );
};

export default MobileAlert;
